declare var google: any;
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(private http:HttpClient, private loginService: LoginService){ }

  logout(token: any): Observable<any> {
    const logoutToken = token ?? localStorage.getItem('token');
    this.flowLog('logout start', { logoutTokenPrefix: String(logoutToken ?? '').slice(0, 8) });
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${logoutToken}`,
      'Accept': 'application/json'
    });

    return this.http.post(environment.Server_URL+'/logout', {}, { headers }).pipe(
      tap(() => {
        this.flowLog('logout api completed');
        this.loginService.resetAuthState();
        this.flowLog('local reset completed after logout api');
      }),
      catchError((error) => {
        console.error('Logout request failed:', error);
        this.flowLog('logout api error', { message: error?.message, status: error?.status });
        this.loginService.resetAuthState();
        this.flowLog('local reset completed after logout api error');
        return of(null);
      })
    );
  }

  private flowLog(step: string, extra: Record<string, any> = {}): void {}
}
